import HeaderSection from '../../../../../components/Header/HeaderSection';
import CardTransparent from '../../../../../components/CockpitCards/CardTransparent';


export default function IgvText() {

    
    return (

      <CardTransparent content = {
        <HeaderSection

            headline_p1 = " Visualize and explore your" 
            headline_grey = "genetic data"
            headline_p2 = "interactively"

            text1 = "Use our interactive genomic data viewer to explore your genetic data in detail. This tool allows you to see exactly where genetic variants are located within specific genes. Type in a correct variant location (in the format: chrX:XX,XXX,XXX-XX,XXX,XXX) to pinpoint the exact position of your variants."
            text2 = "With this tool, you can: See where variants appear – Visualize the exact location of variants on specific chromosomes. Identify affected genes – Understand which genes are impacted by your genetic variations. Interact with your data – Click through chromosomes to explore various genetic markers, including SNPs and other variations."
            text3 = "This tool is widely used in genomic research and clinical diagnostics, helping scientists, clinicians, and genetic counselors understand the potential effects of genetic variants on health and disease. It’s an essential resource for examining how variations in your genes might impact you."

            />
    }/>
            
  )
}